import type { FaireProductEntity } from "../../entity_types/product";

export const p_bx5rbxy3va: FaireProductEntity = {
  token: "p_bx5rbxy3va",
  type: "product",
  name: "HARVEST LIME WOOL TRIANGLE SCARF",
  brandToken: "b_vba92wh7ve",
  brandName: "Beaten Path Co",
  imageUrl:
    "https://cdn.faire.com/fastly/5f899e33263076daa0a97651db666006a51e26da39329ed06fdb385d0cdf33ea.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7b9a46db7c224fd62843f93d665c0712fab872239146e15c7fb84c28332b6599.jpeg",
    "https://cdn.faire.com/fastly/81a1fa2ba53fc7d40549622c7ece3a8a37d7f11c95583d8353ee4b6d28b4dd79.jpeg",
    "https://cdn.faire.com/fastly/fc1d8481838f964f97e76a843b352307141ff9e66e5044db3f19004c64fcbd8f.jpeg",
    "https://cdn.faire.com/fastly/89239d1a9364f9647fcd8baffc477ec233e572670e0bdaf6d987d806ff727a6b.jpeg",
    "https://cdn.faire.com/fastly/bdf3d2ba433434ed54c9e6aad71815be63f9972a65a434b5c811f19f7a4006b3.jpeg",
    "https://cdn.faire.com/fastly/751ccdc2eda86ed9b47254faae70ce0bf7ed85a49858f74f6f0db87acfa1b3c4.png",
  ],
  priceDollars: 14,
  description:
    "A soft pop of color for golden hour walks and slow, sun-soaked days.\n\nThe Marigold Triangle Scarf brings warmth and brightness to your outdoor wardrobe. With its rich golden tone and classic triangle shape, it’s easy to tie around your neck, tuck under your collar, or wear as a headscarf when the breeze picks up.\n\n * Lightweight and breathable \n * Earthy, sweet, and versatile \n * Easy to style—neck, hair, or tucked in a basket bag \n * Perfect for picnics, garden strolls, or rainy day rambles \n * One size fits all \nMaterials: 65% wool, 5% viscose, 10% acrylic, 10% nylon, 10% polyester\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:53.559Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
